import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ReactComponent as LockIcon } from "../assets/lock.svg";

const PasswordScreen = () => {
  const [password, setPassword] = useState("");
  const [hintState, setHintState] = useState(0);
  const navigate = useNavigate();
  const { authenticate } = useAuth();

  useEffect(() => {
    document.title = "Enter Password";
  }, []);

  const handlePasswordSubmit = () => {
    if (password === "120223") {
      authenticate();
      navigate("/video");
    } else {
      alert("Wrong password — try the hint 🙂");
    }
    setPassword("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handlePasswordSubmit();
  };

  const handleRevealHints = () => setHintState((prev) => Math.min(prev + 1, 2));

  return (
    <div className="center-viewport">
      <div className="container">
        <div className="card enter-up" style={{ maxWidth: 720, margin: "24px auto", textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
          <LockIcon style={{ width: 28, height: 28, color: "var(--color-rose)" }} aria-hidden />
          <h2 style={{ margin: 0 }}>Password</h2>
        </div>

        <div style={{ marginTop: 18 }}>
          <input
            className="form-input"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            aria-label="Password"
          />
        </div>

        <div className="form-row">
          <button className="btn btn--primary option-btn" onClick={handlePasswordSubmit}>Submit ✓</button>
          {hintState < 2 && (
            <button className="btn option-btn" onClick={handleRevealHints}>Reveal Hint ❓</button>
          )}
        </div>

        <div style={{ marginTop: 12 }}>
          {hintState >= 1 && <p>🔢 6 numerical digits</p>}
          {hintState === 2 && <p>📅 Official start of us</p>}
        </div>

        <div style={{ marginTop: 18 }}>
          <button className="back-button" onClick={() => navigate("/auth-options")}>Back</button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordScreen;
